import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { endpoints } from './endpoints';
import { CodeActionType, CodeItemSubsetWire, CodeItemWire } from './types';
import { codetableItemEndpoint } from 'app/area/codetable/item/actions-helpers';
import { CodeListWire } from 'app/area/codetable/common';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';

export const api = {
  loadCodeItem: async (codetableId: number, codeId: number): Promise<CodeItemWire> => {

    const request = await new RemoteAdminData(endpoints.code(codetableId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ 'api-version': '3.0' })
      .withId(codeId)
      .single();

    return request.data;
  },

  createCodetableItem: async (actionType: CodeActionType, codetableId: number, codeId: number, codeItem: CodeItemWire) => {
    const request = await new RemoteAdminData(codetableItemEndpoint(actionType, codetableId, codeId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ 'api-version': '3.0' })
      .create(codeItem);

    return request.data;
  },

  duplicateCodeWithDescendants: async (codetableId: number, codeId: number, codeItem: CodeItemWire) => {
    const request = await new RemoteAdminData(endpoints.duplicateCode(codetableId, codeId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ 'api-version': '3.0', withDescendants: true })
      .create(codeItem);

    return request.data;
  },

  saveCodetableItem: async (codetableId: number, codeId: number, codeItem: CodeItemWire) => {
    const request = await new RemoteAdminData(endpoints.code(codetableId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ 'api-version': '3.0' })
      .withId(codeId)
      .save(codeItem);

    return request.data;
  },

  saveSubsetsOnly: async (codetableId: number, codeId: number, codeItem: CodeItemSubsetWire) => {

    const request = await new RemoteAdminData(endpoints.subsets(codetableId, codeId))
      .resource<ApiResponse<CodeItemWire>>()
      .filter({ codeId, optionsCollectionId: codetableId })
      .update(codeItem);

    return request.data;
  },

  loadUomConversionOptions: async (codetableId: number, categoryId: number): Promise<CodeListWire> => {

    const response = await new RemoteAdminData(endpoints.optionsCollectionSearch(codetableId))
      .resource<Response>()
      .filter({ 'api-version': '3.0' })
      .create({
        includeInactiveCodes: { enabled: true },
        limitFieldsTo: [CodeFieldWireKey.code],
        category: { selectedIds: [{ v: categoryId }] }
      });

    const json = await response.json();

    return json.data;
  }
};
